import { GetProjectMenuService } from "../../../../services/plat/MenuService"
import { MenuRecord } from "../../../../utils/storage"

const fetchDynamicMenu = async (menu: MenuRecord) => {
  try {
    const { url, params } = JSON.parse(menu.config)

    const menus = await GetProjectMenuService(url, params)

    if (!Array.isArray(menus)) {
      return []
    }

    return menus.map(({ id, code, name, icon })=> ({
      config: '',
      type: '',
      url: menu.url,
      key: id || code,
      code,
      title: name,
      iconName: icon
    })) as MenuRecord[]
  } catch(error) {
    console.warn('?fetchDynamicMenu', error)
    return []
  }
}

interface Options {
  openKey: string
  selectedKey: string
  selectedUrl: string

  menus: MenuRecord[]

  dynamicUrlMap: {
    [key: string]: string
  }

  dynamicUrlParams?: {
    id: string
    code: string
  }

  crumbs: {
    levelTwoKey: string
    levelTwoUrl: string
    levelTwoTitle: string
    levelThreeKey: string
    levelThreeTitle: string
  }
}

// 侧栏导航
export const takeSliderNav = async (menus: MenuRecord[])=> {
  const options: Options = {
    openKey: '',
    selectedKey: '',
    selectedUrl: '',
    dynamicUrlMap: {},
    menus: [],
    crumbs: {
      levelTwoKey: '',
      levelTwoUrl: '',
      levelTwoTitle: '',
      levelThreeKey: '',
      levelThreeTitle: '',
    }
  }

  // 默认二级选中的菜单开关
  let defaultSelectMenu = false
  // 默认二级展开的菜单开关
  let defaultOpenMenu = false;

  // 动态菜单校验
  let pickDynamicMenu = false

  const clone = JSON.parse(JSON.stringify(menus))

  for(const item of clone) {
    // 此类型会有 children
    if (item.type === 'MENU') {
      if (!Array.isArray(item.children) || item.children.length === 0) {
        continue
      }

      if (!defaultOpenMenu) {
        defaultOpenMenu = true
        options.openKey = item.key
      }

      if (defaultSelectMenu) {
        continue
      }
      
      // 
      defaultSelectMenu = true

      //
      const [first] = item.children

      options.selectedKey = first.key
      options.selectedUrl = first.url

      options.crumbs.levelTwoKey = item.key
      options.crumbs.levelTwoUrl = item.url
      options.crumbs.levelTwoTitle = item.title
      options.crumbs.levelThreeKey = first.key
      options.crumbs.levelThreeTitle = first.title
      continue
    }

    // 普通导航
    if (item.type === 'NAV') {
      if (defaultSelectMenu) {
        continue
      }
      
      defaultSelectMenu = true
      
      options.selectedKey = item.key
      options.selectedUrl = item.url
      options.crumbs.levelTwoKey = item.key
      options.crumbs.levelTwoUrl = item.url
      options.crumbs.levelTwoTitle = item.title

      continue
    }

    if (item.type === 'DYNAV') {
      // 
      options.dynamicUrlMap[item.key] = item.url

      item.children = await fetchDynamicMenu(item)

      if (!defaultOpenMenu && !pickDynamicMenu) {
        defaultOpenMenu = true
        options.openKey = item.key
      }

      if (item.children.length === 0) {
        pickDynamicMenu = true
        item.url = 'noprojectpage'
        continue
      }

      if (pickDynamicMenu) {
        continue
      }

      pickDynamicMenu = true
      defaultSelectMenu = true

      const [first] = item.children

      options.selectedKey = first.key
      options.selectedUrl = first.url
      options.crumbs.levelTwoKey = item.key
      options.crumbs.levelTwoUrl = item.url
      options.crumbs.levelTwoTitle = item.title
      options.crumbs.levelThreeKey = first.key
      options.crumbs.levelThreeTitle = first.title
      options.dynamicUrlParams = {
        id: first.key,
        code: first.code
      }
    }
  }

  options.menus = clone

  return options
}

// 找菜单
export const findMenuItem = (key: string, menus: MenuRecord[]): MenuRecord | null => {
  for(const item of menus) {
    if (item.key === key) {
      return { ...item }
    }
    if (Array.isArray(item.children) && item.children.length > 0) {
      const found = findMenuItem(key, item.children)
      if (found) {
        return found
      }
    }
  }
  return null
}